<template>
  <v-container>
    <v-btn color="primary" outlined :to="{ name: 'AdminTeamCreate' }" router> Create Team </v-btn>

    <v-divider class="my-4"></v-divider>

    <!-- Data Table -->
    <v-data-table-server
      v-model:items-per-page="pagination.limit"
      :items="teams"
      :items-length="count"
      :headers="headers"
      :loading="loading"
      :search="pagination.q"
      item-key="id"
      @update:options="handleLimitChange">
      <template v-slot:[`item.action`]="{ item }">
        <v-btn
          :to="{ name: 'AdminTeamEdit', params: { teamId: item.id } }"
          router
          small
          color="primary">
          Edit
        </v-btn>
      </template>
      <template v-slot:top>
        <v-text-field
          v-model="pagination.q"
          class="ma-2"
          density="compact"
          placeholder="Search team..."
          hide-details></v-text-field>
      </template>
    </v-data-table-server>
  </v-container>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { IPaginationDTO, PaginationDTO } from '@/dtos';
import type { VDataTableServer } from 'vuetify/components';
import { useTeamStore } from '@/stores';

const pagination = ref<IPaginationDTO>(new PaginationDTO());
const teamStore = useTeamStore();
const { data, isLoading } = teamStore.getAllTeamsQuery(pagination);

const teams = computed(() => data.value?.data ?? []);
const count = computed(() => data.value?.count ?? 0);
const loading = computed(() => isLoading.value);

const headers = [
  { title: 'Name', key: 'name', sortable: false },
  { title: 'Actions', key: 'action', sortable: false },
];

const handleLimitChange = (value: VDataTableServer) => {
  pagination.value.buildPagination(value);
};
</script>

<style scoped></style>

<!--
TODOs
* change Edit to Icon
* add Delete icon
* add color sorting

-->
